<template>
  <div id="header" class="header no-nav">
    <header-logo />

    <div class="header-content">
      <div class="pull-right">
        <locale-switcher :current-locale="locale" />
      </div>

      <h2 class="welcome-msg" v-html="welcomeMessage"></h2>

      <p class="wois-description" v-html="$t('vue.components.guest_header.wois_html')"></p>
    </div>
  </div>
</template>

<script>
import LocaleSwitcher from '@/layouts/locale_switcher.vue'
import HeaderLogo from '@/layouts/header_logo.vue'

export default {
  name: 'guest-header',

  props: {
    locale: { type: String, required: true }
  },

  computed: {
    welcomeMessage() {
      return `${this.$t('vue.components.header.welcome_html')} <abbr title="${this.$t('vue.components.header.wois_full')}">W.O.I.S.</abbr>`
    }
  },

  components: {
    LocaleSwitcher,
    HeaderLogo
  }
}
</script>

<style lang="scss" scoped>
@use "variables";

.header {
  position: relative;
  height: variables.$logo-height-small + variables.$nav-container-height;
  background-color: variables.$header-background-color;

  &.no-nav {
    height: variables.$logo-height-small;
  }

  @media screen and (min-width: variables.$screen-sm) {
    &,
    &.no-nav {
      height: variables.$logo-height;
    }
  }

  .locale-switcher {
    margin-right: variables.$container-padding;
    margin-left: variables.$container-padding;
  }

  .header-content {
    padding-top: variables.$container-padding;
    color: variables.$white;

    .welcome-msg {
      font-size: 16px;
      margin-top: 0;
    }
  }
}
</style>
